export const PARTICIPATION_LABELS = {
  single_student: "Jeden uczen",
  shared_students: "Wielu uprawnionych uczniow",
};

export const PAYMENT_LABELS = {
  arrears: "Po zajeciach",
  prepaid: "Z gory",
  installments: "Ratalnie",
};

export const CHARGING_LABELS = {
  fixed_fee: "Stala oplata",
  per_lesson: "Za lekcje",
  consume_package_units: "Pakiet lekcji",
};

export const DURATION_LABELS = {
  fixed_dates: "Daty stale",
  until_school_year_end: "Do konca roku szkolnego",
  valid_for_days_or_months: "Wazny przez dni/miesiace",
};

const valueOrDash = value => (value === undefined || value === null || value === "" ? "-" : String(value));

export const enumOptions = (values, labels) => (
  Object.values(values).map(value => ({ value, text: labels[value] || value }))
);

export const getPaymentStrategyLabel = value => PAYMENT_LABELS[value] || valueOrDash(value);
export const getChargingStrategyLabel = value => CHARGING_LABELS[value] || valueOrDash(value);
